/** Admin views of print orders: their shape, and what an admin may do with one. */

export interface PrintOrderLineItem {
  filename: string;
  size: string;
  finish: string;
  /** Absent on orders placed before the border option existed. */
  border?: boolean;
  quantity: number;
}

export interface PrintOrder {
  print_order_id: string;
  shopify_order_number: string;
  status: string;
  created_at: string;
  download_url?: string;
  fulfilment_failed?: boolean;
  line_items: PrintOrderLineItem[];
  /** The customer's negatives the lab is holding, which can go in the prints' parcel. */
  held_negatives?: number;
}

/**
 * Can an admin start (or restart) fulfilment for this order?
 *
 * Gating this on `fulfilment_failed` alone left a paid order that never started
 * fulfilment with no action at all: no ZIP to download, and no button to produce
 * one. That is exactly the state a payment reconciled late lands in, so the real
 * question is "has this been paid for, and is there still no ZIP?".
 *
 * FULFILLING is excluded deliberately — the workflow is already running, and the
 * regenerate endpoint names each execution uniquely, so a second click would
 * start a duplicate rather than being rejected as a repeat.
 */
export function canRegenerate(order: PrintOrder): boolean {
  if (order.fulfilment_failed) return true;
  if (order.download_url) return false;
  return order.status === 'PAID' || order.status === 'FULFILLED' || order.status === 'FAILED';
}
